"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var static_method_1 = require("../../../shared/utils/static-method");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var conditional_permission_1 = require("./model/conditional-permission");
var CategoryPermissionManagerService = /** @class */ (function () {
    function CategoryPermissionManagerService(permissionService) {
        this.permissionService = permissionService;
    }
    CategoryPermissionManagerService.prototype.getConditionalPermissions = function () {
        var _this = this;
        return this.permissionService.getCategoryPermissions().pipe(operators_1.map(function (value) { return value[-1]; }), operators_1.map(function (value) { return value.filter(function (permission) { return permission.isConditionalPermission && permission.sortId !== 999; }); }), operators_1.switchMap(function (conditionalPermissions) {
            var permissionKeys = conditionalPermissions.map(function (conditionalPermission) { return conditionalPermission.permissionKey; });
            return _this.permissionService.getCategoryConditionalPermissionsExpressions(permissionKeys).pipe(operators_1.map(function (expressions) {
                return conditionalPermissions.map(function (conditionalPermission) {
                    return new conditional_permission_1.ConditionalPermissionModel(conditionalPermission.permissionKey, expressions[conditionalPermission.permissionKey], static_method_1.convertObjectToMultilingualString(conditionalPermission.name), conditionalPermission.categorySystemName, conditionalPermission['description'] || '', conditionalPermission.sortId);
                });
            }));
        }));
    };
    CategoryPermissionManagerService.prototype.createCategoryConditionalPermission = function (categoryConditionalPermissionDto) {
        return this.permissionService.createCategoryConditionalPermission(categoryConditionalPermissionDto);
    };
    CategoryPermissionManagerService.prototype.updateCategoryConditionalPermission = function (categoryConditionalPermissionDto) {
        return this.permissionService.updateCategoryConditionalPermission(categoryConditionalPermissionDto);
    };
    CategoryPermissionManagerService.prototype.checkPermissionIsDeletable = function () {
        return Observable_1.Observable.of(true);
    };
    CategoryPermissionManagerService.prototype.removePermission = function (categoryConditionalPermissionDto) {
        return Observable_1.Observable.of(true);
    };
    CategoryPermissionManagerService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_um_permission_client_js_1.PermissionConfigurationService])
    ], CategoryPermissionManagerService);
    return CategoryPermissionManagerService;
}());
exports.CategoryPermissionManagerService = CategoryPermissionManagerService;
//# sourceMappingURL=category-permission-manager.service.js.map